import request from '@/plugins/axios'

export function getNotificationList (data) {
  return request({
    url: '/notification/getNotificationList',
    method: 'post',
    data
  })
}

export function updateNotiStatus (data) {
  return request({
    url: '/notification/updateNotiStatus',
    method: 'post',
    data
  })
}

export function getNotificationCount (data) {
  return request({
    url: '/notification/getNotificationCount',
    method: 'post',
    data
  })
}